// DEV collapse-card study only. Provisional timings, not recorded clip data.
// Replace these with measured clip timings when the separate video task lands.
export type CardHudKeyframe = {
  t: number
  posture: number
  staggered?: boolean
  parry?: 'just'
}

export const CARD_HUD_DEMO_MAX_POSTURE = 60
export const CARD_HUD_DEMO_FRAMES: readonly CardHudKeyframe[] = [
  { t: 0, posture: 0 },
  { t: 0.45, posture: 25, parry: 'just' },
  { t: 1.3, posture: 39, parry: 'just' },
  { t: 2.3, posture: 39 },
  { t: 2.31, posture: 60, staggered: true, parry: 'just' },
  { t: 4.2, posture: 60, staggered: true },
  { t: 4.5, posture: 0 },
  { t: 5.8, posture: 0 },
]
export const CARD_HUD_DEMO_DURATION = CARD_HUD_DEMO_FRAMES[CARD_HUD_DEMO_FRAMES.length - 1]!.t

export function cardHudDemoAt(elapsedSec: number) {
  const t = (Number.isFinite(elapsedSec) ? Math.max(0, elapsedSec) : 0) % CARD_HUD_DEMO_DURATION
  let i = 0
  while (i + 1 < CARD_HUD_DEMO_FRAMES.length && CARD_HUD_DEMO_FRAMES[i + 1]!.t <= t) i++
  const a = CARD_HUD_DEMO_FRAMES[i]!, b = CARD_HUD_DEMO_FRAMES[i + 1] ?? a
  const k = b.t > a.t ? (t - a.t) / (b.t - a.t) : 0
  let parryAgeSec = 999
  for (let j = 0; j <= i; j++) {
    const f = CARD_HUD_DEMO_FRAMES[j]!
    if (f.parry) parryAgeSec = t - f.t
  }
  return {
    posture: a.posture + (b.posture - a.posture) * k,
    maxPosture: CARD_HUD_DEMO_MAX_POSTURE,
    staggered: !!a.staggered,
    parryAgeSec,
    parryWasJust: parryAgeSec < 999,
  }
}
export type CardHudDemo = ReturnType<typeof cardHudDemoAt>
